export enum LogicalOperator {
  and = "$and",
  or = "$or"
}

export enum ConditionOperator {
  eq = "$eq",
  ne = "$ne",
  gt = "$gt",
  gte = "$gte",
  lt = "$lt",
  lte = "$lte"
}
